var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 6.25C6.38071 6.25 7.5 5.13071 7.5 3.75C7.5 2.36929 6.38071 1.25 5 1.25C3.61929 1.25 2.5 2.36929 2.5 3.75C2.5 5.13071 3.61929 6.25 5 6.25Z",
    stroke: "#103045",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.21045 8.43713C1.59465 7.77212 2.14709 7.21992 2.81228 6.83601C3.47746 6.4521 4.23196 6.24999 4.99999 6.25C5.76801 6.25001 6.5225 6.45213 7.18768 6.83605C7.85286 7.21998 8.40529 7.77219 8.78948 8.43721",
    stroke: "#103045",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.6cb580f96854e8d808fcaccb68143f38.svg";
export { ForwardRef as ReactComponent };